import _defineProperty from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
var eventTypeMap = {
  click: 'onClick',
  mousedown: 'onMouseDown',
  mouseup: 'onMouseUp',
  touchstart: 'onTouchStart',
  touchend: 'onTouchEnd'
};

var ClickAwayListener = function ClickAwayListener(_ref) {
  var _React$cloneElement;

  var children = _ref.children,
      onClickAway = _ref.onClickAway,
      _ref$mouseEvent = _ref.mouseEvent,
      mouseEvent = _ref$mouseEvent === void 0 ? 'click' : _ref$mouseEvent,
      _ref$nodeToIgnore = _ref.nodeToIgnore,
      nodeToIgnore = _ref$nodeToIgnore === void 0 ? null : _ref$nodeToIgnore;
  var node = useRef(null);
  var bubbledEventTarget = useRef(null);
  var mountedRef = useRef(false); // https://github.com/facebook/react/issues/20074

  useEffect(function () {
    setTimeout(function () {
      mountedRef.current = true;
    }, 0);
    return function () {
      mountedRef.current = false;
    };
  }, []);
  useEffect(function () {
    var handleEvents = function handleEvents(event) {
      if (!mountedRef.current) return;
      if (node.current && node.current.contains(event.target) || bubbledEventTarget.current === event.target) return;
      if (nodeToIgnore && nodeToIgnore.contains(event.target)) return;
      onClickAway(event);
    };

    document.addEventListener(mouseEvent, handleEvents);
    return function () {
      document.removeEventListener(mouseEvent, handleEvents);
    };
  }, [mouseEvent, onClickAway, nodeToIgnore]);

  var handleBubbledEvents = function handleBubbledEvents(type) {
    return function (event) {
      bubbledEventTarget.current = event.target;
      var handler = children === null || children === void 0 ? void 0 : children.props[type];
      if (handler) handler(event);
    };
  };

  var handleChildRef = function handleChildRef(childRef) {
    node.current = childRef;
    var ref = children.ref;

    if (typeof ref === 'function') {
      ref(childRef);
    } else if (ref) {
      ref.current = childRef;
    }
  };

  var mappedMouseEvent = eventTypeMap[mouseEvent];
  return React.Children.only(React.cloneElement(children, (_React$cloneElement = {}, _defineProperty(_React$cloneElement, mappedMouseEvent, handleBubbledEvents(mappedMouseEvent)), _defineProperty(_React$cloneElement, "ref", handleChildRef), _React$cloneElement)));
};

ClickAwayListener.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  onClickAway: PropTypes.func.isRequired,
  mouseEvent: PropTypes.oneOf(['click', 'mousedown', 'mouseup', 'touchstart', 'touchend']),
  nodeToIgnore: PropTypes.instanceOf(Element)
};
export { ClickAwayListener };